import { Button as ReactBootstrapButton } from 'react-bootstrap';

export default ReactBootstrapButton;
